import React from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { Calendar } from 'primereact/calendar';

const CakePops = ({ cakePops, productProperties, editable, employees, removeCakePops, handleCakePopsChange }) => {

  const handleDropdownChange = (e, index, key) => {
    const newCakePops = [...cakePops];
    newCakePops[index] = { ...newCakePops[index], [key]: e.value };
    handleCakePopsChange(index, newCakePops[index]);
  };

  const handleInputChange = (event, index, key) => {
    const value = event.target.value;
    const newCakePops = [...cakePops];
    newCakePops[index] = { ...newCakePops[index], [key]: value };
    handleCakePopsChange(index, newCakePops[index]);
  };

  const actionTemplate = (rowData, column) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => removeCakePops(column.rowIndex)} />;
  };

  const getEmployeesByRole = (role) => {
    return employees.filter(employee => employee.roles.includes(role)).map(employee => ({ label: employee.name, value: employee.name }));
  };

  const flavorOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors.cakes.sort().map(cake => ({ label: cake, value: cake }))];
  const coatingOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors.coatings.sort().map(coating => ({ label: coating, value: coating }))];
  const typeOptions = [{ label: 'None', value: null }, ...productProperties[0]?.dessertTypes.cake.sort().map(type => ({ label: type, value: type }))];
  const orientationOptions = [{ label: 'None', value: null }, ...productProperties[0]?.orientations.cakepops.sort().map(orientation => ({ label: orientation, value: orientation }))];


  return (
    // <Card title={
    //   <div style={{
    //     //title with padding
    //     paddingTop: '0.75rem',
    //     paddingBottom: '0.75rem',
    //     paddingLeft: '1rem',
    //     paddingRight: '1rem',
    //     //border
    //     border: '1px solid #eaeaea',
    //     borderRadius: '10px',
    //     //background
    //     background: '#737373',
    //     //shadow
    //     // boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    //     //margin

    //     //text
    //     textAlign: 'left',
    //     fontSize: '1.5rem',
    //     fontWeight: 'bold',
    //     color: 'white',
    //     //letter spacing
    //     letterSpacing: '0.15rem',
    //   }}>

    //     <strong>Cake Pops/Balls</strong>
    //   </div>
    // }>
    <>
      <DataTable value={cakePops} size="small" editMode="cell">
        {editable || cakePops.some(cakePop => cakePop.quantity) ? (
          <Column field="quantity" header="Quantity" editor={editable ? (props) =>
            <InputText value={cakePops[props.rowIndex]?.quantity} onChange={(e) => handleInputChange(e, props.rowIndex, 'quantity')} />
            : null} />
        ) : null}
        {editable || cakePops.some(cakePop => cakePop.flavor) ? (
          <Column field="flavor" header="Flavor" editor={editable ? (props) =>
            <Dropdown value={props.rowData['flavor']} filter
              options={flavorOptions}
              onChange={(e) => handleDropdownChange(e, props.rowIndex, 'flavor')} />
            : null} />
        ) : null}
        {editable || cakePops.some(cakePop => cakePop.shape) ? (
          <Column field="shape" header="Shape" editor={editable ? (props) =>
            <InputText value={cakePops[props.rowIndex]?.shape} onChange={(e) => handleInputChange(e, props.rowIndex, 'shape')} />
            : null} />
        ) : null}
        {editable || cakePops.some(cakePop => cakePop.type) ? (
          <Column field="type" header="Type" editor={editable ? (props) =>
            <Dropdown value={props.rowData['type']} filter options={typeOptions} onChange={(e) => handleDropdownChange(e, props.rowIndex, 'type')} />
            : null} />
        ) : null}
        {editable || cakePops.some(cakePop => cakePop.orientation) ? (
        <Column field="orientation" header="Orientation" editor={editable ? (props) =>
          <Dropdown value={props.rowData['orientation']} filter options={orientationOptions} onChange={(e) => handleDropdownChange(e, props.rowIndex, 'orientation')} />
          : null} />
        ) : null}
        {editable || cakePops.some(cakePop => cakePop.description) ? (
        <Column field="description" header="Description" editor={editable ? (props) =>
          <InputText value={cakePops[props.rowIndex]?.description} onChange={(e) => handleInputChange(e, props.rowIndex, 'description')} />
          : null} />
        ) : null}
         {editable || cakePops.some(cakePop => cakePop.chocolateCoating) ? (
        <Column field="chocolateCoating" header="Chocolate Coating" editor={editable ? (props) =>
          <Dropdown value={props.rowData['chocolateCoating']} filter
            options={coatingOptions}
            onChange={(e) => handleDropdownChange(e, props.rowIndex, 'chocolateCoating')} />
          : null} />
        ) : null}
         {editable || cakePops.some(cakePop => cakePop.coatingColor) ? (
        <Column field="coatingColor" header="Coating Color" editor={editable ? (props) =>
          <InputText value={cakePops[props.rowIndex]?.coatingColor} onChange={(e) => handleInputChange(e, props.rowIndex, 'coatingColor')} />
          : null} />
        ) : null}
        {editable || cakePops.some(cakePop => cakePop.decoratingNotes) ? (
        <Column field="decoratingNotes" header="Decorating Notes" editor={editable ? (props) =>
          <InputText value={cakePops[props.rowIndex]?.decoratingNotes} onChange={(e) => handleInputChange(e, props.rowIndex, 'decoratingNotes')} />
          : null} />
        ) : null}
        {editable || cakePops.some(cakePop => cakePop.price) ? (
        <Column field="price" header="Price" editor={editable ? (props) =>
          <InputText value={cakePops[props.rowIndex]?.price} onChange={(e) => handleInputChange(e, props.rowIndex, 'price')} />
          : null} />
        ) : null}
        {editable && <Column body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} />}
      </DataTable>
    </>
    // </Card>
  );
};

export default CakePops;

